import { useCareerCenterFetch } from "@/modules/careerCenter/hooks/useCareerCenterFetch"
import { useCompanyTrack } from "@/modules/companies/client/hooks/tracking/useCompanyTrack"
import { useCompanyFetch } from "@/modules/companies/client/hooks/useCompanyFetch"

type CompanyExternalLinkTrackFunction = (url: string | URL, type: string) => void

export const useCompanyExternalLinkTrack = (): CompanyExternalLinkTrackFunction => {
  const companyTrack = useCompanyTrack()
  const { dataCompany } = useCompanyFetch()
  const { dataCareerCenter } = useCareerCenterFetch()

  return (url: string | URL, type: string) =>
    companyTrack("external_link_click", {
      company_id: dataCompany?.id,
      destination_url: url,
      link_type: type,
      ...(dataCareerCenter?.intranet && { school_id: dataCareerCenter?.id }),
    })
}
